import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import Modal from '../../components/Modal/Modal'

import getAllActionsByTask from '../../services/actions/getAllActionsByTask'
import putTask from '../../services/tasks/putTask'

import styles from './DailyList.module.css'

const DailyList = (props) => {

  const [ tasks, setTasks ] = useState(props.tasks)
  const [ date, setDate ] = useState(props.firstDay ? new Date(props.firstDay) : new Date())
  const [ actions, setActions ] = useState([])
  const [ tasksAnteriorsPlanificades, setDataAnteriorsPlanificades ] = useState("")
  const [ tasksPosteriorsPlanificades, setDataPosteriorsPlanificades ] = useState("")
  const [ tasksAnteriorsPendents, setDataAnteriorsPendents ] = useState("")
  const [ tasksPosteriorsPendents, setDataPosteriorsPendents ] = useState("")
  const [ disable, setDisable ] = useState(true)
  const [ error, setError ] = useState("")
  const [ update, setUpdate ] = useState(false)

  useEffect(() => {
      const tasksFiltered = props.tasks.filter(element => new Date(element.taskPlanningDate).toISOString().slice(0,10) === new Date(date).toISOString().slice(0,10))
      const tasksFilteredIds = tasksFiltered.map(task => task._id)
      const tasksAnteriorsPlanificades = props.tasks.filter(element => new Date(element.taskPlanningDate).toISOString().slice(0,10) < new Date(date).toISOString().slice(0,10) && element.taskTypeId.typeName === "Planificada" && element.taskStatus === true).length
      const tasksPosteriorsPlanificades = props.tasks.filter(element => new Date(element.taskPlanningDate).toISOString().slice(0,10) > new Date(date).toISOString().slice(0,10) && element.taskTypeId.typeName === "Planificada" && element.taskStatus === true).length
      const tasksAnteriorsPendents = props.tasks.filter(element => new Date(element.taskPlanningDate).toISOString().slice(0,10) < new Date(date).toISOString().slice(0,10) && element.taskTypeId.typeName === "Pendent" && element.taskStatus === true).length
      const tasksPosteriorsPendents = props.tasks.filter(element => new Date(element.taskPlanningDate).toISOString().slice(0,10) > new Date(date).toISOString().slice(0,10) && element.taskTypeId.typeName === "Pendent" && element.taskStatus === true).length
      setDataAnteriorsPendents(tasksAnteriorsPendents)
      setDataPosteriorsPendents(tasksPosteriorsPendents)
      setDataAnteriorsPlanificades(tasksAnteriorsPlanificades)
      setDataPosteriorsPlanificades(tasksPosteriorsPlanificades)
      setTasks(tasksFiltered)
      getAllActionsByTask(tasksFilteredIds)
      .then(actions => {
        setActions(actions)
      })
  },[props.tasks, date, update])

  // Funció canvi de data
  const handleChangeDate = (event) => {
    event.preventDefault()
    if (event.target.id === 'sumar') {
      const newDate = date.setDate(date.getDate() + 1)
      setDate(new Date(newDate))
    } else if (event.target.id === 'restar') {
      const newDate = date.setDate(date.getDate() - 1)
      setDate(new Date(newDate))
    }
    setUpdate(!update)
  }
  
  const handleValidate = (event) => {
    event.preventDefault()
    const id = event.target.id
    let formData = new FormData()
    const dateUnixInitial = new Date(date).toISOString()
    formData.append('taskDoDate', dateUnixInitial)
    formData.append('taskStatus', false)
    let formJson = Object.fromEntries(formData.entries())
    putTask(formJson, id)
    setDisable(false)
    setTimeout(() => {
      setUpdate(!update)
      setDisable(true)
    },3000)
  }

  // Funció canvi data per header
  const handleChangeDateHeader = (event) => {
    const date = new Date(event.target.value)
    setDate(date)
  }

  // Funció per truncar el text
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...'
    }
    return text
  }

  return (
      <div className={styles.listElements}>
        <div className={`${styles.modal} ${disable && styles.disable}`}>
          <Modal error={error} text="Tasca tancada correctament"></Modal>
        </div>
        <div className={styles.dateDaily}>
          <div className={styles.pages}>
            {
              !props.firstDay && <>
                <span className={styles.arrow}><i id="restar" onClick={handleChangeDate} class="fa-regular fa-square-caret-left"></i></span>
                <span className={styles.num} style={tasksAnteriorsPlanificades > 0 ? {'backgroundColor': '#f08080'} : {'backgroundColor': '#83c5be'} }>{tasksAnteriorsPlanificades}</span>
                <span className={styles.num} style={tasksAnteriorsPendents > 0 ? {'backgroundColor': '#f08080'} : {'backgroundColor': '#83c5be'} }>{tasksAnteriorsPendents}</span>
              </>
            }
          </div>
          <div className={styles.pagesCenter}>
            {
              props.firstDay ? 
                <span>{date && date.toLocaleDateString('ca-ES', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/^\w/, c => c.toUpperCase())}</span> :
                <div className={styles.date}>
                  <span className={styles.spanDate}>{date && date.toLocaleDateString('ca-ES', { weekday: 'long'}).replace(/^\w/, c => c.toUpperCase())}</span>
                  <input type="date" value={date.toISOString().slice(0,10)} onChange={handleChangeDateHeader} className={styles.inputDate}></input>
                </div>
            }
          </div>
          <div className={styles.pages}>
            {
              !props.firstDay && <>
                <span className={styles.num} style={tasksPosteriorsPlanificades > 0 ? {'backgroundColor': '#f08080'} : {'backgroundColor': '#83c5be'} }>{tasksPosteriorsPlanificades}</span>
                <span className={styles.num} style={tasksPosteriorsPendents > 0 ? {'backgroundColor': '#f08080'} : {'backgroundColor': '#83c5be'} }>{tasksPosteriorsPendents}</span>
                <span className={styles.arrow}><i id="sumar" onClick={handleChangeDate} class="fa-regular fa-square-caret-right"></i></span>
              </> 
            }
          </div>
        </div>
        <div className={styles.listTasks}>
          <div className={styles.listTasksPlanning}>
            <div className={styles.titlesList}>
              <span>Tasques Planificades</span>
            </div>
            <div className={styles.list}>
            {
              tasks && tasks
              .filter(element => new Date(element.taskPlanningDate).toISOString().slice(0,10) === new Date(date).toISOString().slice(0,10) && element.taskTypeId.typeName === "Planificada")
              .map((element, index) => {
                  const url = `/tasques/${element._id}`
                  const url2 = '/accions'
                  const professionalName = `${element.taskProfessionalId.professionalName} ${element.taskProfessionalId.professionalLastName1}`
                  return (
                    <div key={index} className={styles.task} id={element._id} style={element.taskStatus === false ? {'backgroundColor': '#83c5be'} : {'backgroundColor': '#f08080'} }>
                      <div className={styles.taskDescription}>
                        <span>{element.taskDescription}</span>
                      </div>
                      <div className={styles.taskProfessional}>
                        <span>{professionalName && truncateText(professionalName, 10)}</span>
                      </div>
                      <div className={styles.taskArea}>
                        {
                          element.taskAreaId && <span>PRJ - {element.taskAreaId.areaName}</span>
                        }
                      </div>
                      <div className={styles.taskLabel}>
                        {
                          element.taskLabelId && element.taskLabelId.map((element, index) => {
                            return (
                              <span key={index}>{element.labelName}</span>
                            )
                          })
                        }
                      </div>
                      <div className={styles.actions}>
                          <Link to={url}><i class="fa-solid fa-pen-to-square"></i></Link>
                          <Link to={url2} state={{ id: element._id, professional: element.taskProfessionalId, taskName: element.taskDescription }}><i class="fa-solid fa-square-plus"></i></Link>
                          {/* <span><i id={element._id} onClick={handleValidate} class="fa-regular fa-square-check"></i></span> */}
                          <span><i id={element._id} onClick={props.handleDesactive} class="fa-solid fa-square-xmark"></i></span>
                      </div>
                      <div className={styles.actionsNum}>
                        {
                          actions && 
                          <span>
                            {
                              actions.filter(action => action.actionTaskId._id === element._id).length 
                            }
                          </span>
                        }
                      </div>
                    </div>
                  )
                })
            }
            </div>
          </div>
          <div className={styles.listTasksPending}>
            <div className={styles.titlesList}>
              <span>Tasques No Planificades</span>
            </div>  
            <div className={styles.list}>
              {
                tasks && tasks
                .filter(element => new Date(element.taskPlanningDate).toISOString().slice(0,10) === new Date(date).toISOString().slice(0,10) && element.taskTypeId.typeName === "Pendent")
                .map((element, index) => {
                  const url = `/tasques/${element._id}`
                  const url2 = '/accions'
                  const professionalName = `${element.taskProfessionalId.professionalName} ${element.taskProfessionalId.professionalLastName1}`
                  return (
                    <div key={index} className={styles.task} id={element._id} style={element.taskStatus === false ? {'backgroundColor': '#83c5be'} : {'backgroundColor': '#f08080'} }>
                      <div className={styles.taskDescription}>
                        <span>{element.taskDescription}</span>
                      </div>
                      <div className={styles.taskProfessional}>
                        <span>{professionalName && truncateText(professionalName, 10)}</span>
                      </div>
                      <div className={styles.taskArea}>
                        <span>PRJ - {element.taskAreaId.areaName}</span>
                      </div>
                      <div className={styles.taskLabel}>
                        {
                          element.taskLabelId.map((element, index) => {
                            return (
                              <span key={index}>{element.labelName}</span>
                            )
                          })
                        }
                      </div>
                      <div className={styles.actionsNum}>
                        {
                          actions && 
                          <span>
                            {
                              actions.filter(action => action.actionTaskId._id === element._id).length 
                            }
                          </span>
                        }
                      </div>
                      <div className={styles.actions}>
                          <Link to={url}><i class="fa-solid fa-pen-to-square"></i></Link>
                          <Link to={url2} state={{ id: element._id, professional: element.taskProfessionalId, taskName: element.taskDescription }}><i class="fa-solid fa-square-plus"></i></Link>
                          {/* <span><i id={element._id} onClick={handleValidate} class="fa-regular fa-square-check"></i></span> */}
                          <span><i id={element._id} onClick={props.handleDesactive} class="fa-solid fa-square-xmark"></i></span>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
  )
}

export default DailyList
